// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "assets/chunk." + {"126":"b0306ed5caf9d579a108","269":"341ffb1702c3c9ee3b79","970":"fea0a153eff80a7882e6"}[chunkId] + ".js";
};